import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const AppBarStyled = styled(AppBar)`
  display: flex;
  flex-direction: row;
  background-color: black;
  color: white;
`
const SideContainer = styled.div`
  display: flex;
  padding-left: 24px;
  padding-right: 24px;
  justify-content: flex-end;
  align-items: center;
  flex: 1 0 auto;
`

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
  },
});

class SimpleTabs extends React.Component {
  state = {
    value: 0,
  };

  componentDidMount() {
    const { value } = this.props;
    this.setState({value})
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  getTabs = () => {
    return this.props.tabComponents.map((tab, index) => (
      <Tab
        key={`tab-${index}`}
        label={tab.label}
        component={Link}
        to={tab.path}
      />
    ))
  }

  getComponent = index => {
    return this.props.tabComponents[index].component;
  }

  getSideContent = () => {
    const { sideComponent } = this.props;
    const { value } = this.state;
    if (!sideComponent) {
      return null;
    }

    if (Array.isArray(sideComponent)) {
      return sideComponent[value] && (
        <SideContainer>
          {sideComponent[value]}
        </SideContainer>
      )
    }
    else {
      return sideComponent && (
        <SideContainer>
          {sideComponent}
        </SideContainer>
      )
    } 
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div className={classes.root}>
        <AppBarStyled position="static" color="default">
          <Tabs value={value} onChange={this.handleChange}>
            {this.getTabs()}
          </Tabs>
          {this.getSideContent()}
        </AppBarStyled>
        {this.getComponent(value)}
      </div>
    );
  }
}

SimpleTabs.propTypes = {
  sideComponent: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

SimpleTabs.defaultProps = {
  sideComponent: null,
};

export default withStyles(styles, { withTheme: true })(SimpleTabs);
